import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import DeviceRestriction from "./DeviceRestriction";

const root = ReactDOM.createRoot(document.getElementById("root"));

// ------------------ SERVICE WORKER REGISTRATION ------------------
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      // console.log('Service Worker registered:', registration);
    })
    .catch((err) => {
      console.error('SW registration failed:', err);
    });
}
// -----------------------------------------------------------------



root.render(
  // <React.StrictMode>
  // <DeviceRestriction>
    <App />
  // </DeviceRestriction>
  // </React.StrictMode>
);

// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import DeviceRestriction from "./DeviceRestriction";

// // ────────────────────────────────────────────────
// // ✅ SUPPRESS ResizeObserver LOOP ERRORS (Harmless)
// // ────────────────────────────────────────────────
// const suppressResizeObserverErrors = () => {
//   const resizeObserverErrors = [
//     'ResizeObserver loop completed with undelivered notifications',
//     'ResizeObserver loop limit exceeded'
//   ];

//   // Suppress uncaught errors
//   window.addEventListener('error', (event) => {
//     if (resizeObserverErrors.some(msg => event.message?.includes(msg))) {
//       event.preventDefault();
//       event.stopPropagation();
//       return false;
//     }
//   }, true); // Use capture phase to catch early

//   // Suppress unhandled promise rejections
//   window.addEventListener('unhandledrejection', (event) => {
//     if (resizeObserverErrors.some(msg => event.reason?.message?.includes(msg))) {
//       event.preventDefault();
//       event.stopPropagation();
//     }
//   }, true);
// };

// // Call immediately to start suppressing
// suppressResizeObserverErrors();
// // ────────────────────────────────────────────────

// const root = ReactDOM.createRoot(document.getElementById("root"));

// // ------------------ SERVICE WORKER REGISTRATION ------------------
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('/firebase-messaging-sw.js')
//     .then((registration) => {
//       // console.log('Service Worker registered:', registration);
//     })
//     .catch((err) => {
//       console.error('SW registration failed:', err);
//     });
// }
// // -----------------------------------------------------------------

// root.render(
//   // <React.StrictMode>
//   // <DeviceRestriction>
//     <App />
//   // </DeviceRestriction>
//   // </React.StrictMode>
// );